module.exports = __webpack_public_path__ + "img/h1-interested.8c1f48a4.svg";